import React from "react";
import { useCSVReader } from "react-papaparse";
import UploadIcon from "@atlaskit/icon/glyph/upload";

import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { usePlacementWorksheetContext } from "../../contexts/PlacementWorksheetContext";
import { useSnackbar } from "../../hooks/useSnackbar";
import useAuth from "../../routes/login/AuthContext";
import { putPlacementWorksheetSettingsUnitNumber } from "../../services/PlacementWorksheetApi";

import { Button } from "../../UI/Button";

interface IProps {
  onSuccess: () => Promise<void>;
}

export const UploadUnitNumberButton: React.FC<IProps> = (props) => {
  const { CSVReader } = useCSVReader();
  const { getAuthToken } = useAuth();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { l2Id, l3Id } = usePlacementWorksheetContext();
  const { showSuccessSnackbar, showErrorSnackbar } = useSnackbar();

  const onUploadAccepted = async ({ data }: { data: Record<string, string>[] }) => {
    if (!l2Id || !l3Id) return;

    try {
      const token = await getAuthToken();

      await Promise.all(
        data.map(async (item) => {
          return putPlacementWorksheetSettingsUnitNumber(
            selectedNetworkId,
            l2Id,
            l3Id,
            +item["unit id"],
            item["unit number"],
            token
          );
        })
      );

      showSuccessSnackbar("Successfully completed");

      props.onSuccess();
    } catch (err) {
      showErrorSnackbar();
    }
  };

  return (
    <CSVReader config={{ header: true }} onUploadAccepted={onUploadAccepted}>
      {({ getRootProps }: any) => (
        <Button {...getRootProps()} appearance="primary" iconBefore={<UploadIcon label="upload" />}>
          Upload Unit Numbers
        </Button>
      )}
    </CSVReader>
  );
};
